import { memo } from "react";
import { HStack } from "@/shared/ui/Stack";
import { MenuButton } from "../MenuButton/MenuButton";
import { RATIONS } from "./constants";
import styles from "./FrameAspectRationMenu.module.css";

interface FrameAspectRatioContentProps {
    onClick: (align: string) => void;
}

export const FrameAspectRatioContent = memo(function AlignMenuContent({
    onClick,
}: FrameAspectRatioContentProps) {
    return (
        <HStack wrap="wrap" gap={4}>
            {RATIONS.map((ratio) => (
                <MenuButton key={ratio.value} onClick={() => onClick(ratio.value)}>
                    <p className={styles.text}>{ratio.label}</p>
                </MenuButton>
            ))}
        </HStack>
    );
});
